module.exports = __webpack_public_path__ + "img/frame-icon_1.36f081d.png";